const HEADER_SNIFF_BYTES = 65536

export const parseCsvHeaderLine = (line: string): string[] => {
  if (!line.trim()) {
    return []
  }
  const fields: string[] = []
  let current = ''
  let insideQuotes = false
  // RFC4180: a field is only "quoted" when the quote is its first character. A quote
  // appearing later in an otherwise-unquoted field is a literal character, not a delimiter.
  let atFieldStart = true
  for (let i = 0; i < line.length; i++) {
    const char = line[i]
    if (insideQuotes) {
      if (char === '"') {
        // RFC4180: a doubled quote inside a quoted field is an escaped literal quote,
        // not the closing quote.
        if (line[i + 1] === '"') {
          current += '"'
          i++
        } else {
          insideQuotes = false
        }
      } else {
        current += char
      }
    } else if (char === '"' && atFieldStart) {
      insideQuotes = true
      atFieldStart = false
    } else if (char === ',') {
      fields.push(current.trim())
      current = ''
      atFieldStart = true
    } else {
      current += char
      atFieldStart = false
    }
  }
  fields.push(current.trim())
  return fields
}

// Intentionally case-sensitive (not lowercased on either side): theragen-api's
// CsvImportService reads columns with an exact-case key lookup (`row['Patient Name']`) and
// only trims headers, never lowercases them. Matching that exactly here means a bad-casing
// header fails fast with one clear "missing column" message instead of the server silently
// treating the column as blank on every row. Lowercasing this check would reintroduce that
// mismatch, not fix one.
export const getMissingRequiredColumns = (
  headerColumns: string[],
  requiredColumns: string[],
): string[] => {
  const present = new Set(headerColumns.map(column => column.trim()))
  return requiredColumns.filter(column => !present.has(column))
}

export const readCsvHeaderColumns = async (file: File): Promise<string[]> => {
  const text = await file.slice(0, HEADER_SNIFF_BYTES).text()
  const firstLine = text.split(/\r\n|\r|\n/)[0] ?? ''
  return parseCsvHeaderLine(firstLine)
}
